import React from 'react';
import { Link } from "react-router-dom";
import { Box, Typography, Button, useMediaQuery, useTheme } from '@mui/material';

export default function HeaderSection() {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm')); // xs and sm

  const titleText = "Get Ready for the Future with Leading AI Software Solutions for Global Teams";
  const subtitleText = "Use top AI solutions to save time and money on regulatory operations, to maintain high level quality compliance, and to make precise resource management decisions";

  
  const splitText = (text, wordsPerLine = 3) => {
    const words = text.split(' ');

    
    if (isSmall) {
      const index = words.findIndex(word => word.toLowerCase() === 'solutions');
      if (index !== -1) {
        words.splice(index, 0, '\n'); 
      }
    }

    const lines = [];
    let line = [];
    for (let i = 0; i < words.length; i++) {
      if (words[i] === '\n') {
        lines.push(line.join(' '));
        line = [];
        continue;
      }
      line.push(words[i]);
      if (line.length === wordsPerLine) {
        lines.push(line.join(' '));
        line = [];
      }
    }
    if (line.length) lines.push(line.join(' '));

    return lines.join('\n');
  };


  return (
    <>
      <Box
        sx={{
          width: '100%',
          height: { xs: 380, sm: 400, md: 500 },
          py: { xs: 4, sm: 5, md: 8 },
          px: { xs: 2, sm: 4, md: 10 },
          
          backgroundImage: {
            xs: 'url("/mobile-banner1.png")',
            sm: 'url("/mobile-banner1.png")',
            md: 'url("/Informersubheadinghere.png")',
            lg: 'url("/Informersubheadinghere.png")',
          },
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: { xs: 'column-reverse', sm: 'column-reverse', md: 'row' },

          alignItems: { xs: 'flex-start', md: 'center' },
          justifyContent: 'space-between',
        }}
      >

        {/* LEFT TEXT */}
        <Box sx={{ flex: 1, mb: { xs: 3, md: 0 } }}>

          {/* TITLE — hidden on xs/sm */}
          <Typography
            variant="h1"
            sx={{
              fontWeight: 'bold',
              lineHeight: 1.4,
              mb: 2,
              fontSize: { md: '1.5rem', lg: '1.5rem', sm: '1.1rem', xs: '1.1rem' },
              mt: { xs: 3, sm: 4, md: 0 },   // FIXED
              color: '#000',
              whiteSpace: 'pre-line',
            }}
          >
            {isSmall ? '' : titleText}
          </Typography>


          <Typography
            variant="body1"
            sx={{
              mb: 3,
              fontSize: { md: '1.2rem', lg: '1.2rem', sm: '1rem', xs: '1rem' },

              color: '#000',
              maxWidth: { md: '80%' },
              whiteSpace: 'pre-line',
            }}
          >
            {isSmall ? '' : subtitleText}
          </Typography>

          {/* BUTTON — visible on ALL screens */}
          {!isSmall && (
            <Button
              variant="contained"
              component={Link}
              to="/request-demo"
              sx={{
                backgroundColor: '#03a9f4',
                px: { xs: 3, md: 4 },
                py: { xs: 1, md: 1.2 },
                color: 'white',
                fontWeight: 600,
                borderRadius: '20px',
                fontSize: { xs: '0.9rem', md: '1.1rem' },
                textTransform: 'none',
                '&:hover': {
                  backgroundColor: '#0286c2',
                }
              }}
            >
              Try for Free
            </Button>
          )}
        </Box>

        {/* RIGHT EMPTY COLUMN */}
        <Box sx={{ flex: 1 }}></Box>

      </Box>
      {isSmall && (
        <Box
          sx={{
            backgroundColor: '#fff',   
            justifyContent: 'center',
            alignItems: 'center',
            py: 4,  
             p: 3,
            width: '100%',              
            boxSizing: 'border-box',
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontWeight: 'bold',
              lineHeight: 1.4,
              mb: 2,
              fontSize: { md: '1.8rem', lg: '1.8rem', sm: '1.4rem', xs: '1.4rem' },
              color: '#000',
              whiteSpace: 'pre-line',
            }}
          >
            {splitText(titleText, 10)}
          </Typography>
            <Typography
            variant="body1"
            sx={{
              mb: 3,
              fontSize: { md: '1.2rem', lg: '1.2rem', sm: '1rem', xs: '1rem' },

              color: '#000',
              maxWidth: { md: '80%' },
              whiteSpace: 'pre-line',
            }}
          >
            {isSmall ? subtitleText : ''}
          </Typography>

          <Button
            variant="contained"
            component={Link}
            to="/request-demo"
            sx={{
              backgroundColor: '#03a9f4',
              px: { xs: 3, md: 4 },
              py: { xs: 1, md: 1.2 },
              color: 'white',
              fontWeight: 600,
              borderRadius: '20px',
              fontSize: { xs: '0.9rem', md: '1.1rem' },
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#0286c2',
              },
            }}
          >
            Try for Free
          </Button>
        </Box>
      )}


    </>
  );
}
